import { api } from '../../../services/api/client';
import type { Ad } from '../../../types';

export interface AdPayload {
  title: string;
  content?: string;
  type?: string; // popup | topbar
  image_url?: string;
  button_label?: string;
  button_link?: string;
  target_audience?: string; // all | member | vip
  start_at?: string;
  end_at?: string;
  is_active?: boolean;
  send_email?: boolean;
  priority?: number;
}

export async function fetchActiveAds(audience: string): Promise<Ad[]> {
  const { data } = await api.get<Ad[]>(`/public/ads/active`, { params: { audience } });
  return data;
}
export async function adminListAds(): Promise<Ad[]> {
  const { data } = await api.get<Ad[]>('/admin/ads');
  return data;
}
export async function adminCreateAd(payload: AdPayload): Promise<Ad> {
  const { data } = await api.post<Ad>('/admin/ads', payload);
  return data;
}
export async function adminUpdateAd(id: string, payload: Partial<AdPayload>): Promise<Ad> {
  const { data } = await api.put<Ad>(`/admin/ads/${id}`, payload);
  return data;
}
export async function adminDeleteAd(id: string): Promise<any> {
  const { data } = await api.delete(`/admin/ads/${id}`);
  return data;
}
